import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import { getModuleData } from '../../../selectors/modules';

export default connect((state: AppState, ownProps) =>
  getModuleData(state, ownProps.moduleId)
);
